export function hasPermission(
  user: { permissions?: string[] } | null | undefined,
  requiredPermission: string
): boolean {
  if (!user || !Array.isArray(user.permissions) || user.permissions.length === 0) return false

  const required = String(requiredPermission || '').trim()
  if (!required) return false

  const granted = new Set(
    user.permissions
      .filter(Boolean)
      .map((permission) => String(permission).trim())
      .filter(Boolean)
  )

  if (granted.has('*') || granted.has('admin:*')) return true
  if (granted.has(required)) return true

  const [requiredModule, requiredAction] = required.includes(':')
    ? required.split(':', 2)
    : ['', '']

  if (requiredModule) {
    if (granted.has(`${requiredModule}:*`)) return true
    if (granted.has(`${requiredModule}:manage`)) return true
    if (
      ['read', 'list', 'read_scope'].includes(requiredAction) &&
      granted.has(`${requiredModule}:read_all`)
    ) {
      return true
    }
    if (requiredAction === 'list' && granted.has(`${requiredModule}:read`)) return true
    if (requiredAction === 'read_scope' && granted.has(`${requiredModule}:read`)) return true
  }

  if (required === 'users:read_scope' && granted.has('users:read')) return true
  if (['users:read_scope', 'users:read_all', 'users:read'].includes(required) && granted.has('users:manage')) {
    return true
  }
  if (required.endsWith(':list') && granted.has(required.replace(':list', ':read'))) return true

  // Wildcard grants, e.g., `tasks:*` grants `tasks:read`.
  return Array.from(granted).some((permission) => {
    if (!permission.endsWith(':*')) return false
    const modulePrefix = permission.slice(0, -1)
    return required.startsWith(modulePrefix)
  })
}

export function hasAnyPermission(
  user: { permissions?: string[] } | null | undefined,
  requiredPermissions: string[]
): boolean {
  return requiredPermissions.some((permission) => hasPermission(user, permission))
}

export function hasAllPermissions(
  user: { permissions?: string[] } | null | undefined,
  requiredPermissions: string[]
): boolean {
  return requiredPermissions.every((permission) => hasPermission(user, permission))
}
